import React from 'react'
import styled from 'styled-components'

import Text from 'components/Text'

import Group from './Group'
import { TabularCheckboxProps } from './types'

const TableCheckbox: React.FC<TabularCheckboxProps> = ({ title, columnHeaders, data, isAllExpanded, ...props }) => {
  const handleStateChange = (index: number, isAllExpanded: boolean) => (isExpanded: boolean) => {
    if (isAllExpanded) {
      return
    }

    props.onStateChange?.(index, isExpanded)
  }

  return (
    <Table>
      <thead>
        <tr>
          <th>
            <Text variant="h6" lineHeight="2rem">
              {title}
            </Text>
          </th>
          {columnHeaders.map((header) => (
            <th key={header}>
              <Text variant="h6">{header}</Text>
            </th>
          ))}
        </tr>
      </thead>
      <>
        {data?.map((group, index) => (
          <Group
            key={`${group.subtitle}-${index}`}
            groupIndex={index}
            span={columnHeaders.length + 1}
            isGroupExpanded={isAllExpanded}
            isAllExpanded={isAllExpanded}
            onStateChange={handleStateChange(index, isAllExpanded as boolean)}
            {...group}
            {...props}
          />
        ))}
      </>
    </Table>
  )
}

const Table = styled.table`
  border: 1px solid ${({ theme }) => theme.colors.gray4};
  table-layout: fixed;
  width: 100%;

  thead > tr {
    background-color: ${({ theme }) => theme.colors.white};
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray4};
  }

  th {
    padding: 0.5rem 2rem;
  }

  th:first-child {
    text-align: start;
    width: auto;
  }

  th:not(:first-child) {
    text-align: center;
    width: 100px;
  }
`

export default TableCheckbox
